import { getSpiSubscriptions, subscribeAllSpi, subscribeSpi, unsubscribeSpi, querySpiSubscriptions } from '@/api/spi-subscription'
import { getAdvertisers } from '@/api/open'

export default {
    name: 'SpiSubscription',
    props: {
        showForm: Boolean,
        record: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            queryLoading: false,
            subscribeAllLoading: false,
            unsubscribeLoading: false,
            advertisers: [],
            subscribeTaskId: null,
            checkedKeys: [],
            resultMessage: '',
            resultType: 'info',
            tableGrid: {
                loading: false,
                data: [],
                pagerConfig: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 0,
                    pageSizes: [20, 50, 100, 200, 500]
                },
                columns: [
                    { type: 'checkbox', width: 50, fixed: 'left' },
                    { field: 'account_id', title: '账户ID', width: 140 },
                    { field: 'account_name', title: '账户名称', minWidth: 160 },
                    { field: 'subscribe_task_id', title: '订阅任务ID', width: 120 },
                    { field: 'state', title: '推送状态', width: 100, slots: { default: 'state' } },
                    { field: 'subscribed_at', title: '订阅时间', width: 170 },
                    { field: 'unsubscribed_at', title: '失效时间', width: 170 },
                    { field: 'remark', title: '备注', minWidth: 150, showOverflow: true },
                    { field: 'action', title: '操作', width: 120, fixed: 'right', slots: { default: 'action' } }
                ]
            }
        }
    },
    watch: {
        showForm: {
            immediate: true,
            handler(val) {
                if (val && this.record.id) {
                    this.loadData()
                }
            }
        }
    },
    methods: {
        loadData() {
            // this.loadAdvertisers()
            this.loadSubscriptions()
        },
        loadAdvertisers() {
            getAdvertisers({ account_id: this.record.id, page_size: 500 }).then(res => {
                this.advertisers = res.data.list || []
            })
        },
        loadSubscriptions() {
            this.tableGrid.loading = true
            getSpiSubscriptions({
                media_account_id: this.record.id,
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            }).then(res => {
                this.tableGrid.data = res.data.list || []
                this.tableGrid.pagerConfig.total = res.data.total || 0
            }).finally(() => {
                this.tableGrid.loading = false
            })
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize
            this.loadSubscriptions()
        },
        handleSelectChange({ checked, row }) {
            if (checked) {
                if (!this.checkedKeys.includes(row.account_id)) {
                    this.checkedKeys.push(row.account_id)
                }
            } else {
                const index = this.checkedKeys.indexOf(row.account_id)
                if (index > -1) {
                    this.checkedKeys.splice(index, 1)
                }
            }
        },
        handleSelectAll({ checked }) {
            if (checked) {
                this.checkedKeys = this.tableGrid.data.map(item => item.account_id)
            } else {
                this.checkedKeys = []
            }
        },
        handleSubscribeAll() {
            if (!this.subscribeTaskId) {
                this.$message.warning('请输入订阅任务ID')
                return
            }
            this.$confirm({
                title: '操作提示',
                centered: true,
                content: `确定要订阅该授权账号下的所有广告主吗?`,
                onOk: () => {
                    this.subscribeAllLoading = true
                    subscribeAllSpi({
                        media_account_id: this.record.id,
                        subscribe_task_id: this.subscribeTaskId
                    }).then(res => {
                        if (res.code === 0) {
                            const results = res.data
                            const successCount = results.success ? results.success.length : 0
                            const failedCount = results.failed ? results.failed.length : 0
                            this.resultType = failedCount > 0 ? 'warning' : 'success'
                            this.resultMessage = `订阅完成: 成功${successCount}个, 失败${failedCount}个`
                            this.tableGrid.pagerConfig.currentPage = 1
                            this.loadSubscriptions()
                        }
                    }).catch(err => {
                        this.resultType = 'error'
                        this.resultMessage = err.message || '订阅请求失败'
                    }).finally(() => {
                        this.subscribeAllLoading = false
                    })
                }
            })
        },
        handleResubscribe(record) {
            if (!this.subscribeTaskId) {
                this.$message.warning('请输入订阅任务ID')
                return
            }
            this.subscribeAllLoading = true
            subscribeSpi({
                media_account_id: this.record.id,
                subscribe_task_id: this.subscribeTaskId,
                account_ids: [record.account_id]
            }).then(res => {
                if (res.code === 0) {
                    const results = res.data
                    const failedCount = results.failed ? results.failed.length : 0
                    if (failedCount > 0) {
                        this.$message.error(results.failed[0].message || '重新订阅失败')
                    } else {
                        this.$message.success('重新订阅成功')
                        this.loadSubscriptions()
                    }
                }
            }).catch(err => {
                this.$message.error(err.message || '重新订阅失败')
            }).finally(() => {
                this.subscribeAllLoading = false
            })
        },
        handleSingleUnsubscribe(record) {
            if (!this.subscribeTaskId) {
                this.$message.warning('请输入订阅任务ID')
                return
            }
            this.$confirm({
                title: '操作提示',
                centered: true,
                content: `确定要取消账户 ${record.account_id} 的订阅吗?`,
                onOk: () => {
                    this.unsubscribeLoading = true
                    unsubscribeSpi({
                        media_account_id: this.record.id,
                        subscribe_task_id: this.subscribeTaskId,
                        account_ids: [record.account_id]
                    }).then(res => {
                        if (res.code === 0) {
                            const results = res.data
                            const failedCount = results.failed ? results.failed.length : 0
                            if (failedCount > 0) {
                                this.$message.error(results.failed[0].message || '取消订阅失败')
                            } else {
                                this.$message.success('取消订阅成功')
                                this.loadSubscriptions()
                            }
                        }
                    }).catch(err => {
                        this.$message.error(err.message || '取消订阅失败')
                    }).finally(() => {
                        this.unsubscribeLoading = false
                    })
                }
            })
        },
        handleBatchUnsubscribe() {
            if (!this.subscribeTaskId) {
                this.$message.warning('请输入订阅任务ID')
                return
            }
            if (this.checkedKeys.length === 0) {
                this.$message.warning('请选择要取消订阅的账户')
                return
            }
            this.$confirm({
                title: '操作提示',
                centered: true,
                content: `确定要取消选中的 ${this.checkedKeys.length} 个账户的订阅吗?`,
                onOk: () => {
                    this.unsubscribeLoading = true
                    unsubscribeSpi({
                        media_account_id: this.record.id,
                        subscribe_task_id: this.subscribeTaskId,
                        account_ids: this.checkedKeys
                    }).then(res => {
                        if (res.code === 0) {
                            const results = res.data
                            const successCount = results.success ? results.success.length : 0
                            const failedCount = results.failed ? results.failed.length : 0
                            this.resultType = failedCount > 0 ? 'warning' : 'success'
                            this.resultMessage = `取消订阅完成: 成功${successCount}个, 失败${failedCount}个`
                            this.checkedKeys = []
                            this.loadSubscriptions()
                        }
                    }).catch(err => {
                        this.resultType = 'error'
                        this.resultMessage = err.message || '取消订阅请求失败'
                    }).finally(() => {
                        this.unsubscribeLoading = false
                    })
                }
            })
        },
        querySubscription() {
            if (!this.subscribeTaskId) {
                this.$message.warning('请输入订阅任务ID')
                return
            }
            this.queryLoading = true
            querySpiSubscriptions({
                media_account_id: this.record.id,
                subscribe_task_id: this.subscribeTaskId
            }).then(res => {
                if (res.code === 0) {
                    this.$message.success(`同步订阅状态成功，共${res.data.total || 0}个生效账户`)
                    this.tableGrid.pagerConfig.currentPage = 1
                    this.loadSubscriptions()
                }
            }).catch(err => {
                this.$message.error(err.message || '同步订阅状态失败')
            }).finally(() => {
                this.queryLoading = false
            })
        },
        close() {
            this.subscribeTaskId = null
            this.checkedKeys = []
            this.tableGrid.data = []
            this.tableGrid.pagerConfig.currentPage = 1
            this.resultMessage = ''
            this.$emit('update:showForm', false)
        }
    }
}
